import { push } from 'connected-react-router'
import { Action } from 'redux'
import { Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { StoreDeliverySettingType } from 'types/storeDeliverySetting'
import { FirebaseDocRefType } from 'firebase/index'

const saveStoreDeliverySetting = (
  storeRef: FirebaseDocRefType,
  id: 'yamato',
  storeDeliverySetting: StoreDeliverySettingType
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    await storeRef.collection('store_delivery_settings').doc(id).set(storeDeliverySetting, { merge: true })
    dispatch(hideLoadingAction())
  }
}

export default saveStoreDeliverySetting
